(function(){
  function initHome(root){
    if(!root || root.dataset.d5HomeInitialized==='true') return;
    root.dataset.d5HomeInitialized='true';

    const reveals=root.querySelectorAll('[data-d5-reveal]');
    reveals.forEach(el=>el.classList.add('d5-reveal'));
    if('IntersectionObserver' in window){
      const io=new IntersectionObserver(entries=>entries.forEach(e=>{
        if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target);}
      }),{threshold:.12});
      reveals.forEach(el=>io.observe(el));
    }else reveals.forEach(el=>el.classList.add('is-visible'));

    const heroVideo=root.querySelector('[data-d5-hero-video]');
    const heroPoster=root.querySelector('[data-d5-hero-poster]');
    const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData=Boolean(navigator.connection && navigator.connection.saveData);
    const desktopHero=window.matchMedia('(min-width: 768px)');
    if(heroVideo && !reducedMotion && !saveData){
      let requested=false;
      let playRequest=0;
      const activateDesktopVideo=()=>{
        if(!desktopHero.matches){
          playRequest++;
          heroVideo.pause();
          heroVideo.classList.remove('is-ready','is-playing');
          root.classList.remove('d5-home--video-ready');
          return;
        }
        if(requested) {
          if(heroVideo.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA){
            const request=++playRequest;
            heroVideo.play().then(()=>{
              if(request===playRequest && desktopHero.matches){
                heroVideo.classList.add('is-playing');
                root.classList.add('d5-home--video-ready');
              }
            }).catch(()=>{});
          }
          return;
        }
        requested=true;
        const source=heroVideo.querySelector('source[data-src]');
        if(!source) return;
        source.src=source.dataset.src;
        source.removeAttribute('data-src');
        heroVideo.load();
        const request=++playRequest;
        let started=false;
        const isFullyBuffered=()=>{
          if(!Number.isFinite(heroVideo.duration) || heroVideo.duration<=0 || !heroVideo.buffered.length) return false;
          return heroVideo.buffered.end(heroVideo.buffered.length-1) >= heroVideo.duration-0.25;
        };
        const revealWhenLoaded=()=>{
          if(started || request!==playRequest || !desktopHero.matches || !isFullyBuffered()) return;
          started=true;
          heroVideo.play().then(()=>{
            if(request===playRequest && desktopHero.matches){
              heroVideo.classList.add('is-ready','is-playing');
              root.classList.add('d5-home--video-ready');
            }
          }).catch(()=>{});
        };
        heroVideo.addEventListener('progress',revealWhenLoaded);
        heroVideo.addEventListener('canplaythrough',revealWhenLoaded);
        heroVideo.addEventListener('durationchange',revealWhenLoaded);
        heroVideo.addEventListener('loadeddata',revealWhenLoaded);
        heroVideo.addEventListener('ended',()=>{
          // The loop attribute normally handles this; keep the poster hidden during the loop.
          if(desktopHero.matches) root.classList.add('d5-home--video-ready');
        });
        heroVideo.addEventListener('error',()=>{
          root.classList.remove('d5-home--video-ready');
          heroVideo.classList.remove('is-ready','is-playing');
        },{once:true});
      };
      const scheduleVideoLoad=()=>{
        if(!desktopHero.matches) return;
        if('requestIdleCallback' in window) window.requestIdleCallback(activateDesktopVideo,{timeout:1800});
        else window.setTimeout(activateDesktopVideo,250);
      };
      if(document.readyState==='complete') scheduleVideoLoad();
      else window.addEventListener('load',scheduleVideoLoad,{once:true});
      desktopHero.addEventListener?.('change',()=>{
        if(desktopHero.matches) scheduleVideoLoad();
        else activateDesktopVideo();
      });
    }

    const hero=root.querySelector('[data-d5-parallax]');
    if(hero && !reducedMotion){
      let ticking=false;
      const update=()=>{
        const r=hero.getBoundingClientRect();
        const p=Math.max(0,Math.min(1,(innerHeight-r.top)/(innerHeight+r.height)));
        hero.querySelector('img')?.style.setProperty('transform',`scale(1.04) translateY(${p*2.8}%)`);
        hero.parentElement?.querySelector('.d5-hero__veil')?.style.setProperty('transform',`scale(1.04) translateY(${p*2.8}%)`);
        ticking=false;
      };
      addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(update);ticking=true;}},{passive:true});
      update();
    }

    initCollectionCarousel(root);
  }

  function initCollectionCarousel(homeRoot){
    const root=homeRoot.querySelector('[data-d5-collections-slider]');
    if(!root || root.dataset.d5CarouselInitialized==='true') return;
    root.dataset.d5CarouselInitialized='true';

    const track=root.querySelector('[data-d5-collections-track]');
    const originalSlides=[...root.querySelectorAll('[data-d5-collection-slide]')];
    const prev=root.querySelector('[data-d5-collections-prev]');
    const next=root.querySelector('[data-d5-collections-next]');
    const dots=root.querySelector('[data-d5-collections-dots]');
    const viewport=root.querySelector('[data-d5-collections-viewport]');
    if(!track || originalSlides.length<1) return;

    const total=originalSlides.length;
    let index=1,startX=0,dragging=false,transitioning=false,autoTimer=null;
    const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;

    const firstClone=originalSlides[0].cloneNode(true);
    const lastClone=originalSlides[total-1].cloneNode(true);
    [firstClone,lastClone].forEach(clone=>{
      clone.setAttribute('aria-hidden','true');
      clone.setAttribute('data-d5-clone','true');
      clone.inert=true;
      clone.querySelectorAll('a,button').forEach(el=>el.tabIndex=-1);
    });
    track.append(firstClone);
    track.prepend(lastClone);

    const realIndex=()=>((index-1)%total+total)%total;
    const updateUI=()=>{
      const active=realIndex();
      dots?.querySelectorAll('.d5-collections-slider__dot').forEach((dot,i)=>{
        dot.classList.toggle('is-active',i===active);
        if(i===active) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current');
      });
    };
    const render=(animate=true)=>{
      track.style.transition=animate&&!reducedMotion?'transform .72s var(--ease)':'none';
      track.style.transform=`translate3d(-${index*100}%,0,0)`;
      updateUI();
    };
    const snap=target=>{
      index=target;
      track.style.transition='none';
      track.style.transform=`translate3d(-${index*100}%,0,0)`;
      track.offsetHeight;
      transitioning=false;
      updateUI();
    };
    const go=target=>{
      if(transitioning) return;
      transitioning=true;
      index=target;
      render(true);
      restartAuto();
    };
    const advance=dir=>go(index+dir);

    for(let i=0;i<total;i++){
      const dot=document.createElement('button');
      dot.type='button';
      dot.className='d5-collections-slider__dot'+(i===0?' is-active':'');
      dot.setAttribute('aria-label',`Go to collection ${i+1}`);
      dot.addEventListener('click',()=>{ if(!transitioning) go(i+1); });
      dots?.append(dot);
    }

    track.addEventListener('transitionend',e=>{
      if(e.propertyName!=='transform') return;
      if(index===0) snap(total);
      else if(index===total+1) snap(1);
      else transitioning=false;
    });

    prev?.addEventListener('click',()=>advance(-1));
    next?.addEventListener('click',()=>advance(1));
    viewport?.addEventListener('keydown',e=>{
      if(e.key==='ArrowRight'){e.preventDefault();advance(1);}
      else if(e.key==='ArrowLeft'){e.preventDefault();advance(-1);}
      else if(e.key==='Home'){e.preventDefault();go(1);}
      else if(e.key==='End'){e.preventDefault();go(total);}
    });
    viewport?.addEventListener('pointerdown',e=>{
      if(e.target.closest('.d5-collections-slider__control')) return;
      if(e.pointerType==='mouse' && e.button!==0) return;
      startX=e.clientX;dragging=true;viewport.setPointerCapture?.(e.pointerId);pauseAuto();
    });
    viewport?.addEventListener('pointerup',e=>{
      if(!dragging) return;
      dragging=false;
      const dx=e.clientX-startX;
      if(Math.abs(dx)>45) advance(dx<0?1:-1); else restartAuto();
    });
    viewport?.addEventListener('pointercancel',()=>{dragging=false;restartAuto();});
    viewport?.addEventListener('mouseenter',pauseAuto);
    viewport?.addEventListener('mouseleave',restartAuto);
    viewport?.addEventListener('focusin',pauseAuto);
    viewport?.addEventListener('focusout',e=>{if(!viewport.contains(e.relatedTarget))restartAuto();});

    function pauseAuto(){if(autoTimer){clearInterval(autoTimer);autoTimer=null;}}
    function restartAuto(){
      pauseAuto();
      if(reducedMotion||total<2) return;
      autoTimer=setInterval(()=>advance(1),6500);
    }

    render(false);
    restartAuto();
  }

  function boot(){document.querySelectorAll('[data-d5-home]').forEach(initHome);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  document.addEventListener('shopify:section:load',e=>{
    const root=e.target?.matches?.('[data-d5-home]')?e.target:e.target?.querySelector?.('[data-d5-home]');
    if(root) initHome(root);
  });
})();
